module.exports = __webpack_public_path__ + "img/Rectangle 21.d224c495.png";